module.exports = __webpack_public_path__ + "media/images/symbols/burger-6a866db1201c31f610d8e9d480d8564b.svg";